import React from "react";

export default function CreatePlayer() {
  return <div className="view">CreatePlayer</div>;
}
